<i18n src="@/lang/protocols.yaml"></i18n>

<template lang="pug">
.tab-pane.card-body
    .disclaimer(v-if="showDisclaimer")
        h2 Rechtlicher Hinweis

        p.w-60
            | Die richtige Berechnung und die daraus ggf. entstehenden erforderlichen Maßnahmen zur
            | Erhöhung der Luftdurchlässigkeit der Gebäudehülle und der Innentüren sind eine wesentliche
            | Voraussetzung zur sicheren Funktion von Gasgeräten und Abgasanlagen. Sie sollte daher nur
            | von Fachleuten ausgeführt werden, die entsprechende Kenntnis von der Lüftung von
            | Wohngebäuden und vom Zusammenhang einer ausreichenden Verbrennungsluftversorgung mit der
            | sicheren Abgasführung haben.

        p
            | Deshalb übernimmt der Luftverbundrechner keine Haftung für die gesetzlichen Regelungen,
            | Formeln, Tabellen und Diagramme der TRGI, Ihren Benutzerangaben und den daraus baurechtlich
            | getroffenen Lösungsmaßnahmen.

        p
            | Dieses Protokoll ist nur zusammen mit einer ordnungsgemäß durchgeführten und dokumentieren
            | Messung der Verbrennungsluft vor Ort rechtsbeständig.

        button.btn.btn-primary.mt-4(@click="tosAccepted = true") Akzeptieren &amp; fortfahren

    form(v-else, @submit.prevent="saveAndContinue")
        .form-group
            label.label-title Protokolltitel:
            input.form-control(v-model="protocol.title", type="text", required)
            small.form-text.text-muted Bspw. die Adresse des Objekts oder eine Kundennummer.

        character-count-textarea(v-model="protocol.description", label="Protokollbeschreibung:", :charlimit="320")

        //- <b-form-group label="Skizze:" :description="protocol.image && 'Ausgewählte Datei: ' + protocol.image.name || 'Laden Sie hier Ihre angefertigte Skizze hoch, um sie dem Protokoll anzuhängen.'">
        //-     <b-form-file v-model="protocol.image" placeholder="Datei auswählen..."></b-form-file>
        //- </b-form-group>

        h3.h6 Allgemeine Hinweise zur Raumskizze:

        ol
            li Grundriss der Nutzungseinheit auf einem Papier zeichnen</li>
            li Fenster und alle Türen einzeichnen (Außentüren markieren)</li>
            li Räume mit Kubikmeter (m<sup>3</sup>) eintragen</li>
            li Beginn mit dem Aufstellungsraum der Hauptfeuerstätte als Nr. 1</li>
            li
                | Feuerstätten mit Kurzbezeichnungen und Art der Feuerstätte nach TRGI und Nennleistung bzw. fiktive Nennleistung eintragen
                |
                span.text-muted z.B. KW, B11BS, 15kW.
                br
                span.text-muted.small Alle Abkürzungen zu den Feuerstätten finden sie unter Hilfe.

        button.btn.btn-primary.mt-4(type="submit") Speichern &amp; Weiter
</template>

<script>
import CharacterCountTextarea from '@/components/CharacterCountTextarea'
import { Protocol } from 'trgi'

export default {
    components: {
        CharacterCountTextarea
    },
    props: {
        value: {
            type: Protocol,
            default: function () {
                return new Protocol()
            }
        }
    },
    data () {
        // Clone into a Local Instance of the Tab
        const protocol = new Protocol(this.value)

        return {
            tosAccepted: false,
            protocol
        }
    },
    computed: {
        showDisclaimer () {
            // Show for New Protocols Only
            return !this.$route.query.id && !this.tosAccepted
        }
    },
    watch: {
        // When Protocol gets modified on another Tab, refresh Local Protocol Variable
        value (value) {
            this.protocol = new Protocol(value)
        }
    },
    methods: {
        saveAndContinue () {
            this.$emit('save', new Protocol(this.protocol))
        }
    }
}
</script>
